"use client";
import {
  useMenuContext
} from "../__chunks/ZVTAGWLT.js";
import "../__chunks/BPJQU32H.js";
import {
  useCompositeSeparator
} from "../__chunks/3OQPDTG6.js";
import "../__chunks/CMELOF3N.js";
import "../__chunks/RA2MZPUM.js";
import "../__chunks/J4JPXPLD.js";
import "../__chunks/EDI7THRR.js";
import "../__chunks/THGRQCVD.js";
import "../__chunks/UUT76IPH.js";
import "../__chunks/JS4W7WDG.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/I6MSISV2.js";
import "../__chunks/FPBGCFAS.js";
import "../__chunks/KQWO6ME3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/4R3V3JGP.js";

// src/menu/menu-separator.tsx
var TagName = "hr";
var useMenuSeparator = createHook(
  function useMenuSeparator2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useMenuContext();
    store = store || context;
    props = useCompositeSeparator(__spreadValues({ store }, props));
    return props;
  }
);
var MenuSeparator = forwardRef(function MenuSeparator2(props) {
  const htmlProps = useMenuSeparator(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuSeparator,
  useMenuSeparator
};
